export const capitalize = (str?: string): string => {
    const rest = str?.toLowerCase().slice(1) ?? "";
    return str?.charAt(0)?.toUpperCase().concat(rest) ?? "";
  };
  